import "./CardNotification.scss";
import { useMemo } from "react";
import { Actions, Calendar } from "@/icons";
import { Button, Row } from "@/components";

type Variant = "primary" | "secondary";

type NotificationIcon = "calendar" | "actions";

type CardNotificationProps = {
  type: string;
  date: string;
  icon: NotificationIcon;
  showBadge?: boolean;
  title: string;
  text: string;
  variant?: Variant;
  onClickEdit?: () => void;
  onClickManage?: () => void;
  onClickGoToDetails?: () => void;
  showExpired?: boolean;
  buttonMaxWidth?: boolean;
  onClickRightManage?: () => void;
  rightManageTitle?: string;
  goToDetailsTitle?: string;
};

export const CardNotification = ({
  type,
  onClickEdit,
  onClickRightManage,
  rightManageTitle = "Gestisci",
  goToDetailsTitle = "Più dettagli",
  showExpired = false,
  buttonMaxWidth,
  onClickGoToDetails,
  icon = "calendar",
  variant = "primary",
  onClickManage,
  date,
  title,
  showBadge = false,
  text,
}: CardNotificationProps) => {
  const isSecondary = variant === "secondary";

  const iconToRender = useMemo(() => {
    if (icon === "calendar") {
      return <Calendar width={24} height={26} color="slate-28" />;
    }
    if (icon === "actions") {
      return <Actions width={24} height={26} color="slate-28" />;
    }
  }, [icon]);

  const cardClasses = ` ${
    isSecondary
      ? "bg-lightblue-a03 ui-card-notifications-secondary"
      : "bg-white"
  } shadow br-x4  `;

  const iconContainer = ` ui-card-notifications-icon base-row   ${
    isSecondary ? "bg-white" : "bg-lightblue-a03"
  }   `;

  const manageButtonClasses = ` ${
    buttonMaxWidth ? "w-full" : "ui-card-notifications-button"
  }  `;

  return (
    <div className={cardClasses}>
      <Row px={"x24"} py={"x8"} justifyContent={"space-between"}>
        <p className={"fs-7 fw-semibold"}> {type}</p>
        <p className={"fs-7 fw-semibold"}>{date}</p>
      </Row>
      <div className={"ui-card-notifications-divider "} />
      <Row pt={"x16"} px={"x24"} pb={"x24"} gap={"x16"}>
        <div className={iconContainer}>
          {showBadge && (
            <div className={"ui-card-notifications-badge-container"}>
              <div className={"ui-card-notifications-badge"} />
            </div>
          )}
          {iconToRender}
        </div>
        <div className={"w-full"}>
          <div className={"mb-x24"}>
            <p className={"my-x8 fs-5 fw-semibold"}>{title}</p>
            {showExpired && (
              <Row mb={"x8"}>
                <div
                  className={
                    "py-x4 px-x16  bg-status-error text-white rounded fw-semibold fs-7"
                  }
                >
                  SCADUTO
                </div>
              </Row>
            )}
            <p>{text}</p>
          </div>

          {onClickManage && (
            <div className={"base-row justify-content-center"}>
              <Button className={manageButtonClasses} onClick={onClickManage}>
                Gestisci
              </Button>
            </div>
          )}

          <Row justifyContent={"flex-end"} className={"w-full gap-x16"}>
            {!!onClickGoToDetails && (
              <Button onClick={onClickGoToDetails} variant={"secondary"}>
                {goToDetailsTitle}
              </Button>
            )}
            {onClickRightManage && (
              <div className={"base-row justify-content-center"}>
                <Button onClick={onClickRightManage}>{rightManageTitle}</Button>
              </div>
            )}

            {!!onClickEdit && (
              <Button
                onClick={onClickEdit}
                bg="transparent"
                textColor="primary"
              >
                Modifica
              </Button>
            )}
          </Row>
        </div>
      </Row>
    </div>
  );
};
